import React from "react";
import "./FloatButton.scss";
import { Link, useLocation } from "react-router-dom";
import { performConversionScript } from "../../../shared/ConversionHelper";

interface FloatButtonProps {
  message?: string;
  ctaText?: string;
  ctaPath?: string;
}

const DEFAULT_MESSAGE = "세이브오피스로 비즈니스의 신뢰도를 높여보세요.";
const DEFAULT_CTA_TEXT = "빠른 상담하기";
const DEFAULT_CTA_PATH = "/consult";
const SCROLL_DELTA_THRESHOLD = 6;
const SHOW_TRIGGER_Y = 80;

const FloatButton = ({
  message = DEFAULT_MESSAGE,
  ctaText = DEFAULT_CTA_TEXT,
  ctaPath = DEFAULT_CTA_PATH,
}: FloatButtonProps) => {
  const [visible, setVisible] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    let scrollY = window.scrollY;
    let rafId: number | null = null;

    function updateVisibility() {
      if (rafId != null) {
        return;
      }

      rafId = window.requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        const delta = currentScrollY - scrollY;

        if (currentScrollY <= SHOW_TRIGGER_Y) {
          setVisible(false);
        } else if (Math.abs(delta) >= SCROLL_DELTA_THRESHOLD) {
          setVisible(delta > 0);
        }

        scrollY = currentScrollY;
        rafId = null;
      });
    }

    window.addEventListener("scroll", updateVisibility, { passive: true });
    return () => {
      window.removeEventListener("scroll", updateVisibility);
      if (rafId != null) {
        window.cancelAnimationFrame(rafId);
      }
    };
  }, []);

  return (
    <div className={`float-button-container ${visible ? "visible" : ""}`}>
      <div className="float-button-wrapper">
        <p>{message}</p>
        <Link
          to={`${ctaPath}${location.search}`}
          onClick={performConversionScript}
        >
          <button className="float-button">{ctaText}</button>
        </Link>
      </div>
    </div>
  );
};

export default FloatButton;
